import type { ClassProvider, Type } from '@angular/core';
import { ERROR_HANDLER_INJECTION_TOKEN } from './error-handler.token';
import type { CappusErrorHandler } from './cappus-error-handler';

export function provideErrorHandlers(handlerClasses: Type<CappusErrorHandler>[]): ClassProvider[] {
  return handlerClasses.map(handlerClass => ({
    provide: ERROR_HANDLER_INJECTION_TOKEN,
    useClass: handlerClass,
    multi: true,
  }));
}
